import BuilderModel from "~/models/tracked/builderModel";
import IRepo from "~/interfaces/repo";
import Repo from "~/state/modules/repo";
import ObjectModelTrigger from "~/models/objectModelTriggers/objectModelTrigger";
import Guid from "~/helpers/guid";
import Vue from "vue";

export default class RelatedModelPrimaryKey extends BuilderModel {

  related_model_id: string;
  primary_key: string;

  static repo: IRepo<RelatedModelPrimaryKey> = new Repo<RelatedModelPrimaryKey>('relatedModelPrimaryKeys', RelatedModelPrimaryKey);

  constructor(parent:  ObjectModelTrigger, private fieldName: string, json: any = {} ) {
    super();
    this.defineProperty('client_id', json['client_id'] || Guid.create());
    this.defineProperty('related_model_id', null);
    this.defineProperty('primary_key', null);

    this.fieldName = fieldName;
    this.parent = parent;
    this.rootModel = parent.rootModel;
    this.loadFromJson(json, this.rootModel);

    RelatedModelPrimaryKey.repo.add(this);
    Vue.set(parent[fieldName], this.client_id , this);
  }

  get rootName(): string {
    return this.fieldName;
  }


}